var _ = require('lodash');

module.exports = {
  getInitialState() {
    return {
      currentlyFiltering: ''
    };
  },

  linkToFilter() {
    var linkFunction = (evt) => {
      this.setState({
        currentlyFiltering: evt.target.value
      });
    };

    var value = this.state.currentlyFiltering;

    return {
      onChange: linkFunction,
      value: value
    };
  },

  filterArray(array) {
    var result;

    if (!this.state.currentlyFiltering) return array;

    result = _.filter(array, (currentRow) => {
      return _.some(currentRow, (currentColumn) => {
        var toFilter = _.isPlainObject(currentColumn) ? '' + currentColumn.value : '' + currentColumn;
        return toFilter && toFilter.toLowerCase().indexOf(this.state.currentlyFiltering.toLowerCase()) !== -1;
      });
    });

    return result;
  }
};
